import * as React from 'react';
import {
  VerticalStackedBarChart,
  IVerticalStackedChartProps,
  IVerticalStackedBarChartProps,
} from '@fluentui/react-charting';
import { DefaultPalette, IStyle, DefaultFontStyles } from '@fluentui/react/lib/Styling';
import { DirectionalHint, Icon } from '@fluentui/react';
import { Text } from '@fluentui/react';
import { useTranslation } from 'react-i18next';
import { User } from '../../../system/User';

interface IPanelVerticalStackedBarChart {
  // data: CollaboratorActivityStatus;
  data: any;
  user: User;
}
const PanelVerticalStackedBarChart = (props: IPanelVerticalStackedBarChart) => {
  const colorActivities = '#564aa3';
  const { t, i18n } = useTranslation();

  const _chartData: IVerticalStackedChartProps[] = React.useMemo(() => {
    const chartPoints = props.data?.estadoHoras?.map((itemHours, idx) => {
      if (props.user.hasPowerUserPrivileges()) {
        return [
          {
            data: itemHours.horas.horasCargadasPlantilla,
            legend: t('Horas cargadas'),
            color: DefaultPalette.blueLight,
          },
          {
            data: itemHours.horas.horasLicencia,
            legend: t('Horas licencia'),
            color: DefaultPalette.purpleLight,
          },
          { data: itemHours.horas.horasFaltantes, legend: t('Horas faltantes'), color: '#db756e' },
          {
            data: itemHours.horas.horasExcedidas,
            legend: t('Horas excedidas'),
            color: DefaultPalette.neutralSecondary,
          },
          {
            data: itemHours.horas?.horasTagPendientes ?? 0,
            legend: t('Horas tag pendientes'),
            color: DefaultPalette.yellowDark,
          },
        ];
      } else {
        return [
          {
            data: itemHours.horas.horasCargadasPlantilla,
            legend: t('Horas cargadas'),
            color: DefaultPalette.blueLight,
          },
          {
            data: itemHours.horas.horasLicencia,
            legend: t('Horas licencia'),
            color: DefaultPalette.purpleLight,
          },
          { data: itemHours.horas.horasFaltantes, legend: t('Horas faltantes'), color: '#db756e' },
          {
            data: itemHours.horas.horasExcedidas,
            legend: t('Horas excedidas'),
            color: DefaultPalette.neutralSecondary,
          },
          {
            data: itemHours.horas?.horasTagPendientes ?? 0,
            legend: t('Horas tag pendientes'),
            color: DefaultPalette.yellowDark,
          },
        ];
      }
    });

    return chartPoints?.map((item, idx) => {
      return { chartData: item, xAxisPoint: props.data?.estadoHoras?.[idx]?.periodo };
    });

  }, [props.data, t]);

  const textStyle: IStyle = {
    fill: DefaultPalette.black,
    fontSize: '10px',
    lineHeight: '14px',
  };

  const customStyles: IVerticalStackedBarChartProps['styles'] = () => {
    return {
      chart: {
        paddingBottom: '14px',
      },
      chartLabel: {
        color: DefaultPalette.blueMid,
        ...DefaultFontStyles.large,
      },
      xAxisText: {
        ...textStyle,
      },
      xAxis: {
        selectors: {
          line: {
            opacity: 1,
          },
        },
      },
      root: {
        width: "100%",
        minHeight: 150,
        overflowX: 'auto',
        display: "block",
        paddingBottom: 10
      },
    };
  };

  return (
      <div className="mt-2">
        <Text className="ml-2" variant="medium" style={{ fontSize: '14px' }}>
          <Icon iconName={'Clock'} className="text-icon"></Icon>
          {t('Horas registradas por mes')}
        </Text>

        <div className={`mt-1 xAxisVisible`} style={{ height: "300px" }}>
            <VerticalStackedBarChart
                height={300}
                key={props.data.estadoHoras.length}
                hideLegend={true}
                data={_chartData ?? []}
                noOfCharsToTruncate={12}
                showXAxisLablesTooltip
                // "rotateXAxisLables" solo rota cuando "wrapXAxisLables" esta apagado y el eje X es de tipo string
                // (que es nuestro caso, ya que xAxisPoint = periodo es un string). Por eso se quito wrapXAxisLables.
                rotateXAxisLables={true}
                barWidth={15}
                yAxisTickCount={5}
                // eslint-disable-next-line react/jsx-no-bind
                styles={customStyles}
                calloutProps={{
                  directionalHint: DirectionalHint.topCenter,
                }}
                // eslint-disable-next-line react/jsx-no-bind
                yAxisTickFormat={(x: number | string) => `${x} h`}
                // margins={{ left: 50, bottom: 60 }}
                legendProps={{
                  // allowFocusOnLegends: true,
                  styles: {
                    legend: {
                      marginTop: '0px',
                    },
                    rect: {
                      borderRadius: '3px',
                    }
                  },
                }}
                isCalloutForStack={true}
                // xAxisPadding={0.}
                // eslint-disable-next-line react/jsx-no-bind
                // onRenderCalloutPerDataPoint={(props) =>
                //   props ? (
                //     <ChartHoverCard
                //       XValue={props.xAxisCalloutData}
                //       Legend={props.legend}
                //       YValue={`${props.yAxisCalloutData || props.data} h`}
                //       color={props.color}
                //     />
                //   ) : null
                // }
            />
        </div>
      </div>
  );
};

export default PanelVerticalStackedBarChart;
